module.exports = __webpack_public_path__ + "static/media/ghost_yellow.afa4c41b.jpg";